import {
  Component,
  Vue,
  InjectReactive,
  Prop,
} from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { PimcoreLayoutInput, PimcoreLayoutPanel } from '@/types/entity';
import PimcoreEntityIntrospection from '@/classes/graphql-introspection/PimcoreEntityIntrospection';
import { CrudOperation } from '@/types/CrudOperation';

@Component
export default class LayoutMixin extends Vue {
  /**
   * Хелпер получения макета pimcore по типу
   */
  @Getter('layoutFieldsByType', { namespace: 'entity' })
  layoutFieldsByType!: (entity: string, type: string) => Array<PimcoreLayoutPanel|PimcoreLayoutInput>;

  @State('operation', { namespace: 'entity' })
  operation!: CrudOperation;

  @InjectReactive() pimcoreIntrospection!: PimcoreEntityIntrospection;

  @Prop({ default: '' })
  entityName!: string;

  @Prop({ default: 'form' })
  formType!: string;

  get entity() {
    return this.entityName || this.$route.params.entityName;
  }

  get layoutEntity(): string {
    if (this.operation === CrudOperation.create) {
      return this.pimcoreIntrospection?.entity || this.entity;
    }
    return this.entity;
  }

  /**
   * Массив описания полей макета(custom layout) формы Pimcore
   */
  get formLayoutFields(): Array<PimcoreLayoutInput|PimcoreLayoutPanel> {
    return this.entity
      ? this.layoutFieldsByType(this.layoutEntity, this.formType)
      : [];
  }

  get previewLayoutFields(): Array<PimcoreLayoutInput|PimcoreLayoutPanel> {
    return this.entity
      ? this.layoutFieldsByType(this.layoutEntity, 'preview')
      : [];
  }
}
